import { render, staticRenderFns } from "./resourceSupplierManageList.vue?vue&type=template&id=4fb97b50&scoped=true"
import script from "./resourceSupplierManageList.vue?vue&type=script&lang=js"
export * from "./resourceSupplierManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceSupplierManageList.vue?vue&type=style&index=0&id=4fb97b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb97b50",
  null
  
)

export default component.exports